module.exports = __webpack_public_path__ + "img/76286.3a3c7c34.svg";